import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { finalize, map, Observable, of } from 'rxjs';

import { JsonConvert } from 'json2typescript';
import { HvlResponse } from '@hvlng/framework-bff/core';

import { KovanTaskModel, PreloaderService } from 'ui-shared';

import { HrConfigurationService } from '../config/hr-config-service';

@Injectable({
    providedIn: 'root',
})
export class HrBpmnForInfraService {
    endpoint: string;

    constructor(
        private httpClient: HttpClient,
        private configService: HrConfigurationService,
        private uiPreloaderService: PreloaderService,
    ) {
    }

    /**
     *
     * @param model
     * @returns
     */
    public complete(model: KovanTaskModel): Observable<KovanTaskModel> {
        const pattern = model['completeEndPointPath'];

        if (!pattern) {
            return of(model);
        }

        if (model.processDefinitionKey === 'HrPerCardApprovalProcess' || model.processDefinitionName === 'process_kovanHrCoreCommonApprove') // Uyarlama Projelerinde process_kovanHrCoreCommonApprove kullanılıyor
            return this.callPersonnelCommonBpmn(model);
        else if (model.processDefinitionKey === 'hr_per_degree_advancement_approval')
            return this.callDegreeAdvancementBpmn(model);
        else if (model.processDefinitionKey === 'hr_per_personnel_import_approval' || model.processDefinitionKey === 'hr_per_mass_termination_approval')
            return this.callPersonnelImportAndMassTerminationBpmn(model);
        else
            return of(model);
    }

    private callDegreeAdvancementBpmn(taskModel: KovanTaskModel): Observable<KovanTaskModel> {
        let address = this.getFullAddressForPersonnelService(taskModel);
        let decision = taskModel.bpmnState === 'APPROVED' ? 'APPROVED' : 'DRAFT';

        let model = {
            taskId: taskModel.id,
            decision: decision,
            comment: taskModel.comment,
        };

        return this.callService(address, model, taskModel);
    }

    private callPersonnelImportAndMassTerminationBpmn(taskModel: KovanTaskModel): Observable<KovanTaskModel> {
        let address = this.getFullAddressForPersonnelService(taskModel);
        let decision = taskModel.bpmnState === 'APPROVED' ? 'APPROVE' : 'REJECT';

        let model = {
            taskId: taskModel.id,
            decision: decision,
            comment: taskModel.comment,
        };

        return this.callService(address, model, taskModel);
    }

    private getFullAddressForPersonnelService(taskModel: KovanTaskModel): string {
        this.endpoint = this.configService.config?.hr?.personnel;
        const converter = new JsonConvert();

        const mergeCharacter = this.endpoint.endsWith('/') || taskModel.completeEndPointPath.startsWith('/') ? '' : '/';
        return this.endpoint + mergeCharacter + taskModel.completeEndPointPath;
    }

    private callPersonnelCommonBpmn(taskModel: KovanTaskModel): Observable<KovanTaskModel> {
        this.uiPreloaderService.show();
        let address: string = this.getFullAddressForPersonnelService(taskModel);
        let businessKey = taskModel.businessKey.split(':');


        if (businessKey.length < 2) {
            businessKey = [businessKey[0], businessKey[0]];
        }
        if
        (taskModel.bpmnState === 'APPROVED') {
            var model = {
                taskId: taskModel.id,
                id: businessKey[1],
                personalDataApprovalStatus: 'APPROVED',
            };

        } else if (taskModel.bpmnState === 'REJECTED') {
            var model = {
                taskId: taskModel.id,
                id: businessKey[1],
                personalDataApprovalStatus: 'REJECTED',
            };

        } else if (taskModel.bpmnState === 'REVISION') {
            var model = {
                taskId: taskModel.id,
                id: businessKey[1],
                personalDataApprovalStatus: 'REVISION',
            };

        }

        return this.callService(address, model, taskModel);
    }

    private findValueInObject(object, key) {
        var value;
        Object.keys(object).some(function(k) {
            if (k === key) {
                value = object[k];
                return true;
            }
            if (object[k] && typeof object[k] === 'object') {
                value = this.findVal(object[k], key);
                return value !== undefined;
            }
        });
        return value;
    }

    private callService(address: string, model: any, taskModel: KovanTaskModel): Observable<KovanTaskModel> {
        this.uiPreloaderService.show();
        return this.httpClient
            .post<HvlResponse<KovanTaskModel>>(address, model)
            .pipe(
                map(() => {
                    return taskModel;
                }),
                finalize(() => this.uiPreloaderService.hide()),
            );
    }
}
